import { useEffect, useState } from 'react'

export type ArrayData = Array<Record<string, unknown>>
export type Data = {
    barries: ArrayData
    bowtie: ArrayData
    consequences: ArrayData
    scenarios: Record<string, unknown>
    ships: ArrayData
    staggering: ArrayData
    threats: ArrayData
}
export type UseJson = {
    code: number | undefined
    message: string
    data: Data
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const logger = (...args) => {
    console.debug('[bowtie api fetch] ', ...args)
}

const PLUGIN_NAME = 'plugin-ocyan-bowtie'
const BASE_URL = `/services/${PLUGIN_NAME}`

function api(endpoint: string, setter: React.Dispatch<React.SetStateAction<Record<string, unknown>>>): void {
    const url = BASE_URL + endpoint

    logger('requesting to ' + url)

    fetch(url, {
        method: 'GET',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' }
    })
        .then(res => {
            if (res.ok) {
                return res.json()
            } else {
                throw new Error(`Failed to retrieve bowtie ${endpoint}, status ${res.status} - ${res.statusText}`)
            }
        })
        .then(json => {
            setter(json)
        })
        .catch(err => {
            logger('failed to retrieve ' + url, err)
        })
}

// eslint(react-hooks/rules-of-hooks) recomenda que as funções sobre estado e efeito tenham nomes como: useSomething
export function useJSON(/* event */): Data {
    const [json, setJson] = useState<Data>({
        barries: [],
        bowtie: [],
        consequences: [],
        scenarios: {},
        ships: [],
        staggering: [],
        threats: []
    })

    useEffect(() => {
        api('/json', (res: UseJson) => setJson(res.data))
    }, [])

    return json
}
